import { iconColorTypes, settingsIconTypes } from 'global/enums/settingsIconTypes'
import React, { useState } from 'react'
import { Icon, List, Popup } from 'semantic-ui-react'
import _ from 'lodash'

export const PopupSelect = ({ items, dataItem, handleMenuAction, icon }) => {

  const [open, setOpen] = useState(false)

  const getColor = (item) => {
    if (!dataItem) return iconColorTypes?.[item] || 'blue';
    return dataItem?.[item] ? iconColorTypes?.[item] : 'grey'
  }

  return (
    <Popup
      open={open}
      closeOnTriggerBlur={false}
      basic
      pinned
      flowing
      hoverable
      onClose={() => setOpen(false)}
      position='bottom right'
      className='popup-select'
      trigger={
        <Icon name={icon ? icon : open ? 'arrow up' : 'arrow down'} color={'black'} inverted circular onClick={(e) => {
          e.stopPropagation()
          setOpen(o => !o)
        }} />
      }
      content={
        <List selection divided >
          {_.map(items, (item, key) => (
            <List.Item
              key={key || item}
              style={{ color: 'white' }}
              onClick={(e) => {
                e.stopPropagation()
                handleMenuAction(item)
                setOpen(false)
              }}
            >
              <List.Icon
                name={settingsIconTypes?.[key || item] || item?.icon || 'options'}
                color={item?.iconColor || getColor(key || item)}
              />
              <List.Content>
                {_.startCase(key || item)}
              </List.Content>
            </List.Item>
          ))}
        </List>
      }
    />
  )
}
